module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmWUlfBxc4EsA.16d9701c.woff2";